import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from './services/users.service';
import { AdvsService } from './services/advs.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'nativtube';
  showAdv = false
  adv: { num: number, text: string, link: string, name: string,type:string }
  userId: number
  url
  showMessege: boolean = false

  constructor(private renderer: Renderer2, private el: ElementRef, private router: Router,
    private advsService: AdvsService, private userService: UsersService) {
    this.url = window.location.href
    router.events.subscribe(e => {
      this.scrollToTheTop()
    })
  }

  ngOnInit(): void {
    // this.userService.getDataInInitAspxPage().subscribe(s => {
    //   console.log('sadfasdfsdfasfasfsafsafsaf', s)
    //   console.log('Response:', s);
    //   const parts: string[] = s.split("#");
    //   const ip: string = parts[parts.length - 2];
    //   console.log("ip:", ip)
    // }, e => console.log('error asdfasfdsadfsafdadfasdfsdf', e))

    // this.userService.getUserIp1().subscribe(s => {
    //   console.log('sadfasdfsdfasfasfsafsafsaf', s)
    //   console.log('Response:', s);

    // }, e => console.log('error asdfasfdsadfsafdadfasdfsdf', e))
    this.userService.currentUser.subscribe(u => {
      this.userService.sessionDetails.subscribe(s => {

        if (u) {
        this.userId = u.userId
        // const lastShowMessegeString = localStorage.getItem('lastShowMessege')
        // if (lastShowMessegeString) {
        //   const lastShowMessege = new Date(JSON.parse(lastShowMessegeString));
        //   const currentDate = new Date();
        //   // this.showMessege = (currentDate.getTime() - lastShowMessege.getTime()) > 3 * 24 * 60 * 60 * 1000 && !u.profiles.find(p => p === -223)
        //   this.showMessege = !u.profiles.find(p => p === -223 || p === -230 || p === -231)
        // } else {
        //   const hasYoutubeProfiles = u.profiles.find(p => p === -223 || p === -230 || p === -231)
        //   console.log('hasYoutubeProfiles', hasYoutubeProfiles)
        //   console.log('!hasYoutubeProfiles', !hasYoutubeProfiles)
        //   // Handle the case where 'lastShowMessege' is not present in localStorage
        //   this.showMessege = !hasYoutubeProfiles
        }
        // console.log("((u.activeList === 2 || u.activeList === 6)  || s['NativVersion'].localeCompare('4.5.17.0') > -1)", ((u.activeList === 2 || u.activeList === 6) || s['NativVersion'].localeCompare('4.5.17.0') > -1))
        // console.log("(u.activeList === 2 || u.activeList === 6) ", (u.activeList === 2 || u.activeList === 6))
        // console.log("s['NativVersion'].localeCompare('4.5.17.0')", s['NativVersion'].localeCompare('4.5.17.0'))
        // console.log("s['NativVersion']", s['NativVersion'])
        // const userType = this.userService.getUserType(u.userTypeId)
        // this.showMessege = this.showMessege && ((u.activeList === 2 || u.activeList === 6) || s['NativVersion'].localeCompare('4.5.17.0') > -1)
        // && !userType.IS_USER_GUR && !userType.IS_USER_MAIL_ONLY && !userType.IS_USER_PERSONAL
        // }
        this.showMessege = true
      })
    })
    setTimeout(() => {
      this.showAdv = true
      this.changeImage()
    }, 3500);
    localStorage.setItem('showBlocked', 'false')


  }

  showScrollButton: boolean;

  changeImage() {
    this.adv = this.advsService.getRandAdv()
    const newSrc = 'assets/images/advs/' + this.adv.num + '/80_850.'+this.adv.type;
    const imageElement = this.el.nativeElement.querySelector('#adv-img');
    this.renderer.setAttribute(imageElement, 'src', newSrc);
  }

  addClick() {
    this.advsService.saveClick(this.adv.name, 'bottom', '')
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.scrollY > 0) {
      this.showScrollButton = true;
    } else {
      this.showScrollButton = false;
    }
  }

  scrollToTheTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }

  closeAdv() {
    this.showAdv = false
    setTimeout(() => {
      this.showAdv = true
    }, 1000 * 60 * 5);
  }

  closeMessege() {
    this.showMessege = false
    localStorage.setItem('lastShowMessege', JSON.stringify(new Date()))
  }

  openProspect() {
    this.showMessege = false
    this.userService.openProspect().subscribe(u => {
      localStorage.setItem('openProspect', 'true')
      Swal.fire('הפנייה התקבלה', 'פנייתך התקבלה ותטופל בהקדם', 'success')
    })
  }
}
